export default "__VITE_ASSET__DvCBvlsj__"